























































































































































































































































































































































































import { PartnerPracticeApi } from '@/api/partner-practice';
import { Appointment } from '@/shared/appointments/appointment';
import { AppointmentOutcomeProduct } from '@/shared/appointments/appointment-outcome-product';
import { AppointmentProductPaymentDetails } from '@/shared/appointments/appointment-product-payment-details';
import { InstructionType } from '@/shared/instruction-type';
import { LocationType } from '@/shared/location-type';
import { PartnerPractice } from '@/shared/partner-practice';
import { AppointmentCancellationType } from '@/shared/types/appointment-cancellation-type';
import { AppointmentExecutorType } from '@/shared/types/appointment-executor-type';
import { AppointmentNoInstructionType } from '@/shared/types/appointment-no-instruction-type';
import { AppointmentOutcomeType } from '@/shared/types/appointment-outcome-type';
import { AppointmentPaymentStatusType } from '@/shared/types/appointment-payment-status-type';
import { AppointmentType } from '@/shared/types/appointment-type';
import { User } from '@/shared/user';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { appointmentProductTypeDescription, appointmentTypeDescription, cancellationTypeDescription, executorTypeDescription, instructionTypeDescription, locationTypeDescription, noInstructionTypeDescription, outcomePaymentStatusTypeDescription, outcomeTypeDescription, productPaymentStatusTypeDescription, reasonTypeDescription } from './appointment-utilities';

const typesModule = namespace('types');
const usersModule = namespace('users');

const partnerPracticeApi = new PartnerPracticeApi();

@Component
export default class ViewAppointmentDialog extends Vue {
    @typesModule.Getter('appointmentPaymentStatusTypes') private paymentStatusTypes!: Array<AppointmentPaymentStatusType>;
    @typesModule.Getter('appointmentTypes') private appointmentTypes!: Array<AppointmentType>;
    @typesModule.Getter('appointmentCancellationTypes') private cancellationTypes!: Array<AppointmentCancellationType>;
    @typesModule.Getter('appointmentNoInstructionTypes') private noInstructionTypes!: Array<AppointmentNoInstructionType>;
    @typesModule.Getter('appointmentOutcomeTypes') private outcomeTypes!: Array<AppointmentOutcomeType>;
    @typesModule.Getter('appointmentExecutorTypes') private executorTypes!: Array<AppointmentExecutorType>;

    @usersModule.Getter('users') private users!: Array<User>;

    @Prop({ required: true }) private appointment!: Appointment;
    @Prop({ required: true }) private visible!: boolean;

    private isVisible: boolean = this.visible;
    private tabIndex: number = 0;
    private partnerPractice: PartnerPractice | null = null;

    private get showAddressTab(): boolean {
        return this.appointment.locationType === LocationType.Office || this.appointment.locationType === LocationType.Home;
    }

    private get showReasonsTab(): boolean {
        return this.appointment.reasons != null && this.appointment.reasons.length > 0;
    }

    private get showOutcomeTab(): boolean {
        return this.appointment.outcome != null;
    }

    private get showProductsTab(): boolean {
        return this.appointment.outcome != null && this.appointment.outcome.products != null && this.appointment.outcome.products.length > 0;
    }

    private get showNumberOfPayments(): boolean {
        if (this.appointment.outcome == null || this.appointment.outcome.paymentDetails == null || this.appointment.outcome.paymentDetails.paymentStatusId == null) {
            return false;
        }

        const paymentStatusType = this.paymentStatusTypes.find((type) => type.id === this.appointment.outcome!.paymentDetails!.paymentStatusId);

        return paymentStatusType == null ? false : paymentStatusType.isPartPayment;
    }

    private get showSigningDate(): boolean {
        if (this.appointment.outcome == null || this.appointment.outcome.paymentDetails == null || this.appointment.outcome.paymentDetails.paymentStatusId == null) {
            return false;
        }

        const paymentStatusType = this.paymentStatusTypes.find((type) => type.id === this.appointment.outcome!.paymentDetails!.paymentStatusId);

        return paymentStatusType == null ? false : paymentStatusType.isSigningBooked;
    }

    private get addressLine1(): string | null {
        if (this.appointment.locationType !== LocationType.Office) {
            return this.appointment.addressLine1;
        }

        if (this.partnerPractice == null) {
            return '';
        }

        const address = this.partnerPractice.addresses.find((a) => a.id === this.appointment.partnerPracticeAddressId!);
        return address == null ? '' : address.addressLine1;
    }

    private get addressLine2(): string | null {
        if (this.appointment.locationType !== LocationType.Office) {
            return this.appointment.addressLine2;
        }

        if (this.partnerPractice == null) {
            return '';
        }

        const address = this.partnerPractice.addresses.find((a) => a.id === this.appointment.partnerPracticeAddressId!);
        return address == null ? '' : address.addressLine2;
    }

    private get addressLine3(): string | null {
        if (this.appointment.locationType !== LocationType.Office) {
            return this.appointment.addressLine3;
        }

        if (this.partnerPractice == null) {
            return '';
        }

        const address = this.partnerPractice.addresses.find((a) => a.id === this.appointment.partnerPracticeAddressId!);
        return address == null ? '' : address.addressLine3;
    }

    private get town(): string | null {
        if (this.appointment.locationType !== LocationType.Office) {
            return this.appointment.town;
        }

        if (this.partnerPractice == null) {
            return '';
        }

        const address = this.partnerPractice.addresses.find((a) => a.id === this.appointment.partnerPracticeAddressId!);
        return address == null ? '' : address.town;
    }

    private get county(): string | null {
        if (this.appointment.locationType !== LocationType.Office) {
            return this.appointment.county;
        }

        if (this.partnerPractice == null) {
            return '';
        }

        const address = this.partnerPractice.addresses.find((a) => a.id === this.appointment.partnerPracticeAddressId!);
        return address == null ? '' : address.county;
    }

    private get postcode(): string | null {
        if (this.appointment.locationType !== LocationType.Office) {
            return this.appointment.postcode;
        }

        if (this.partnerPractice == null) {
            return '';
        }

        const address = this.partnerPractice.addresses.find((a) => a.id === this.appointment.partnerPracticeAddressId!);
        return address == null ? '' : address.postcode;
    }

    private includeProductDetails(product: AppointmentOutcomeProduct): boolean {
        if (product == null) {
            return false;
        }

        if (product.instructionType === InstructionType.NotInstructed) {
            return false;
        }

        if (product.instructionType === InstructionType.Instructed) {
            return true;
        }

        return product.instructedValue != null;
    }

    private productPayments(product: AppointmentOutcomeProduct): Array<AppointmentProductPaymentDetails> | null {
        if (product == null || product.paymentDetails == null) {
            return null;
        }

        const payments = [...product.paymentDetails];
        const orderedPayments = payments.sort((n1, n2) => {
            if (n1.index == null || n2.index == null) {
                return 0;
            }

            if (n1.index > n2.index) {
                return 1;
            }

            if (n1.index < n2.index) {
                return -1;
            }

            return 0;
        });

        return orderedPayments;
    }

    private clientName(appointment: Appointment): string {
        if (appointment.clients == null || appointment.clients.length < 1) {
            return '';
        }

        if (appointment.clients.length < 2) {
            return `${appointment.clients[0].firstName} ${appointment.clients[0].lastName}`;
        }

        if (appointment.clients[0].lastName != null && appointment.clients[1].lastName != null && appointment.clients[0].lastName.toLowerCase() === appointment.clients[1].lastName.toLowerCase()) {
            return `${appointment.clients[0].firstName} & ${appointment.clients[1].firstName} ${appointment.clients[0].lastName}`;
        }

        return `${appointment.clients[0].firstName} ${appointment.clients[0].lastName} & ${appointment.clients[1].firstName} ${appointment.clients[1].lastName}`;
    }

    private userName(userId: string | null): string {
        if (userId == null) {
            return '';
        }

        const user = this.users.find((u) => u.id === userId);

        return user == null ? '' : `${user.firstName == null ? '' : user.firstName} ${user.lastName == null ? '' : user.lastName}`;
    }

    private appointmentTypeDescription(appointmentTypeId: string | null): string {
        return appointmentTypeDescription(appointmentTypeId);
    }

    private locationTypeDescription(locationType: LocationType): string {
        return locationTypeDescription(locationType);
    }

    private outcomeTypeDescription(appointment: Appointment): string {
        if (appointment.outcome == null) {
            return appointment.isRebooked ? 'Re-booked' : 'Pending';
        }

        const description = outcomeTypeDescription(appointment.outcome.outcomeTypeId);
        return appointment.isRebooked ? `${description} - Re-booked` : description;
    }

    private reasonTypeDescription(reasonTypeId: string | null): string {
        return reasonTypeDescription(reasonTypeId);
    }

    private instructionTypeDescription(instructionType: InstructionType): string {
        return instructionTypeDescription(instructionType);
    }

    private executorTypeDescription(executorTypeId: string): string {
        return executorTypeDescription(executorTypeId);
    }

    private cancellationTypeDescription(cancellationTypeId: string): string {
        return cancellationTypeDescription(cancellationTypeId);
    }

    private noInstructionTypeDescription(noInstructionTypeId: string): string {
        return noInstructionTypeDescription(noInstructionTypeId);
    }

    private productTypeDescription(productTypeId: string | null): string {
        return appointmentProductTypeDescription(productTypeId);
    }

    private paymentStatusTypeDescription(paymentStatusTypeId: string): string {
        return outcomePaymentStatusTypeDescription(paymentStatusTypeId);
    }

    private productPaymentStatusTypeDescription(paymentDetails: Array<AppointmentProductPaymentDetails>): string {
        return productPaymentStatusTypeDescription(paymentDetails);
    }

    private partPaymentStatusTypeDescription(paymentStatusId: string): string {
        if (paymentStatusId == null) {
            return '';
        }

        const paymentStatusType = this.paymentStatusTypes.find((type) => type.id === paymentStatusId);

        if (paymentStatusType == null) {
            return '';
        }

        if (paymentStatusType.isPartPayment) {
            return 'Pending';
        }

        return paymentStatusType.value;
    }

    @Watch('visible')
    private onVisibleChanged(newValue: boolean): void {
        this.isVisible = newValue;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

    public async mounted(): Promise<void> {
        await Promise.all([
            this.$store.dispatch(`types/loadTypesAsync`),
            this.$store.dispatch(`users/loadAllUsersAsync`),
        ]);

        this.partnerPractice = await partnerPracticeApi.getPartnerPracticeAsync(this.appointment.partnerPracticeId!);
    }
}
